<template>
  <div class="virtual_guard__phone_prompt virtual_guard__phone_landscape">
    <touch-events 
      :sublocation_id="sublocation_id" 
      @closePhoneValidation="updateShowPhonePrompt(false)"></touch-events>
  </div>
</template>

<script>
import TouchEvents from "@/views/components/TouchEvents.vue";
export default {
  data() {
    return{

    }
  },
  components: {
    TouchEvents,
  },
  methods: {
    toggleItem(index) {
      this.items[index].isOpen = !this.items[index].isOpen
    }
  },
  props: {
    sublocation_id: {
      type: String,
      required: true,
    }
  },
}
</script>

<style scoped>
.accordion-container {
  max-width: 800px;
  margin: 0 auto;
}

.accordion-item {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.accordion-item.active {
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  cursor: pointer;
  background-color: #f8f9fa;
  transition: background-color 0.2s;
}

.header:hover {
  background-color: #f1f3f5;
}

.title {
  margin: 0;
  font-size: 1.1rem;
  color: #2c3e50;
}

.arrow {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-right: 2px solid #666;
  border-bottom: 2px solid #666;
  transform: rotate(-45deg);
  transition: transform 0.3s ease;
}

.active .arrow {
  transform: rotate(45deg);
}

.content {
  padding: 0 16px;
  border-top: 1px solid #eee;
  background-color: white;
  color: #444;
  line-height: 1.6;
}

.slide-enter-active, .slide-leave-active {
  transition: all 0.3s ease;
  max-height: 500px;
}

.slide-enter, .slide-leave-to {
  opacity: 0;
  max-height: 0;
  padding: 0 16px;
}
</style>